import SpinnerSolid from '../UI/Spinner/SpinnerSolid';

const LoadingOverlaySpinner = () => {
  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]'>
      <div className='flex justify-center w-full'>
        <SpinnerSolid color='midnight' size='medium' />
      </div>
    </div>
  );
};

export default LoadingOverlaySpinner;
